import React from 'react';

const ProductHeader = ({ name, description, category, barcode }) => {
  return (
    <div className="mb-3">
      <div className="flex items-center gap-2 mb-1.5">
        {barcode && (
          <span className="text-xs text-gray-500">
            SKU: {barcode}
          </span>
        )}
      </div>
      <h1 className="text-2xl font-bold text-gray-900 mb-1.5">{name}</h1>
      {description && (
        <p className="text-sm text-gray-600 leading-relaxed">{description}</p>
      )}
    </div>
  );
};

export default ProductHeader;